import { render, staticRenderFns } from "./FSelectDict.vue?vue&type=template&id=2d1b676f&scoped=true&"
import script from "./FSelectDict.vue?vue&type=script&lang=js&"
export * from "./FSelectDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b676f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1b676f')) {
      api.createRecord('2d1b676f', component.options)
    } else {
      api.reload('2d1b676f', component.options)
    }
    module.hot.accept("./FSelectDict.vue?vue&type=template&id=2d1b676f&scoped=true&", function () {
      api.rerender('2d1b676f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dict/FSelectDict.vue"
export default component.exports